import { IColumn, IRow } from '@/interfaces/interfaces'

export enum ActionTypes {
  REORDER = 'reorder',
  SORTBY = 'sort_by',
  FILTER = 'filter',
  REVERSE = 'reverse',
  TRANSPOSE = 'transpose',
  TOP_AND_BOTTOM = 'top_and_bottom',
  STRING_FILTER = 'string_filter',
  SHIFT_LABELS = 'shift_labels',
  COPY_ORDER = 'copy_order',
  SUM_VALUES = 'sum_values',
  PCT_UPLIFT = 'pct_uplift',
  POINT_CHANGE = 'point_change',
  STRING_SPLIT = 'string_split',
  DELETE_POSITION = 'delete_position',
  DELETE_LABEL = 'delete_label',
  ROUND = 'round'
}

export interface BaseAction<T = null, K = number[]> {
  id?: number
  actionType: ActionTypes
  by?: K | number[]
  axis: 0 | 1
  specs?: T | object
  shapeDataSelection: number
  linkedDataSelection?: number
  valid?: boolean
}

export interface ActionProps<T = null> {
  isVisible: boolean
  clearOptions?: boolean
  columns?: IColumn[]
  rows?: IRow[]
  onSubmit?: (formValues) => void
  onCancel: () => void
  initialValues?: Partial<T>
}

type ReorderBy = {
  columns: (string | number)[]
  rows: (string | number)[]
}

export type ReorderAction = Omit<BaseAction<object, ReorderBy>, 'axis'>
export type TransposeAction = Omit<BaseAction, 'axis' | 'by'>
export type ReverseAction = Omit<BaseAction, 'by'>
export type SortByAction = BaseAction<{ ascending: boolean }>
export type FilterAction = BaseAction
export type TopAndBottomAction = BaseAction
export type CopyOrder = BaseAction<object, number[]>
export type SumValuesAction = Omit<BaseAction, 'by'>
export type PctUpliftAction = BaseAction<{ output_name: string }>
export type PointChangeAction = BaseAction<{ output_name: string }>
export type StringSplitSpecs = {
  delimiter: string
  segment: number
  keep_delimiter: boolean
  strip?: boolean
}
export type StringSplitAction = Omit<BaseAction<StringSplitSpecs>, 'axis' | 'by'>
export type DeletePositionAction = Omit<BaseAction, 'specs'>
export type DeleteLabelAction = Omit<BaseAction<{ terms: string[] }>, 'by'>
export type RoundSpecs = {
  decimal_places: number
  half: 'half_up' | 'half_even'
}
export type RoundAction = Omit<BaseAction<RoundSpecs>, 'axis' | 'by'>

export type Action<T extends ActionTypes = null> = T extends ActionTypes.REORDER
  ? ReorderAction
  : T extends ActionTypes.FILTER
  ? FilterAction
  : T extends ActionTypes.SORTBY
  ? SortByAction
  : T extends ActionTypes.REVERSE
  ? ReverseAction
  : T extends ActionTypes.TRANSPOSE
  ? TransposeAction
  : T extends ActionTypes.TOP_AND_BOTTOM
  ? TopAndBottomAction
  : T extends ActionTypes.COPY_ORDER
  ? CopyOrder
  : T extends ActionTypes.SUM_VALUES
  ? SumValuesAction
  : T extends ActionTypes.DELETE_POSITION
  ? DeletePositionAction
  : T extends ActionTypes.DELETE_LABEL
  ? DeleteLabelAction
  : T extends ActionTypes.ROUND
  ? RoundAction
  :
      | ReorderAction
      | TransposeAction
      | ReverseAction
      | SortByAction
      | FilterAction
      | TopAndBottomAction
      | SumValuesAction
      | DeletePositionAction
      | DeleteLabelAction
      | RoundAction
